export const SIGN_IN_INITIATE = '/sign-in/initiate'
export const SIGN_IN_VERIFY = '/sign-in/verify'
export const SIGN_UP = '/sign-up'
export const SIGN_OUT = '/sign-out'
export const REFRESH_TOKEN = '/token/refresh'
export const LOGOUT = '/logout'
export const FETCH_ACCOUNT = '/account'
export const UPDATE_ACCOUNT = '/account'
export const VERIFY_UPDATE_FIELD = '/account/verify-update'
